import type { CabinMemoryItem, ContextPhase } from '../../core';
import type { CSSProperties } from 'react';

function ageLabel(now: number, lastSeenAt: number): string {
  const age = Math.max(0, now - lastSeenAt);
  return age < 0.1 ? 'JUST NOW' : `${age.toFixed(1)} MIN AGO`;
}

export default function CabinMemoryLens({
  visible,
  phase,
  now,
  item,
}: {
  visible: boolean;
  phase: ContextPhase;
  now: number;
  item: CabinMemoryItem | null;
}) {
  if (!item) return null;
  return (
    <aside
      className="cabin-memory-lens"
      data-phase={phase}
      data-visible={visible}
      aria-hidden={!visible}
      aria-label="Cabin Memory semantic evidence"
    >
      <header>
        <span>MEMORY / 01</span>
        <b>{phase === 'verified' ? 'LOCATION VERIFIED' : 'SEMANTIC MATCH'}</b>
      </header>
      <div className="memory-object-row">
        <div className="memory-object-glyph" aria-hidden="true"><i /></div>
        <div>
          <small>OBJECT</small>
          <strong>{item.label}</strong>
          <p>{item.location}</p>
        </div>
        <div className="memory-confidence">
          <small>CONFIDENCE</small>
          <output>{Math.round(item.confidence * 100)}%</output>
        </div>
      </div>
      <div className="memory-confidence-track" aria-label={`Semantic match confidence ${Math.round(item.confidence * 100)} percent`}>
        <i style={{ '--memory-confidence': `${Math.round(item.confidence * 100)}%` } as CSSProperties} />
      </div>
      <div className="memory-data-flow" aria-label="Gaze to object to location relationship">
        <span>GAZE</span><i /><span>OBJECT</span><i /><span>LOCATION</span>
      </div>
      <dl>
        <div><dt>LAST SEEN</dt><dd>{ageLabel(now, item.lastSeenAt)}</dd></div>
        <div><dt>OWNER</dt><dd>{item.owner.toUpperCase()}</dd></div>
        <div><dt>IMPORTANCE</dt><dd>{item.importance.toUpperCase()}</dd></div>
        <div><dt>SOURCE</dt><dd>SIMULATED EVENT</dd></div>
      </dl>
      <footer><i aria-hidden="true" /> VISUAL · POSITION · TIME · SEMANTICS</footer>
    </aside>
  );
}
